/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_Platformquestions_Body1Inputs */

const en_settings_support_platformquestions_body1 = /** @type {(inputs: Settings_Support_Platformquestions_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any issues that you think cannot be resolved internally, please use the following link to raise a support ticket:`)
};

/**
* | output |
* | --- |
* | "For any issues that you think cannot be resolved internally, please use the following link to raise a support ticket:" |
*
* @param {Settings_Support_Platformquestions_Body1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_support_platformquestions_body1 = /** @type {((inputs?: Settings_Support_Platformquestions_Body1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_Platformquestions_Body1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_support_platformquestions_body1(inputs)
});
export { settings_support_platformquestions_body1 as "settings_support_platformQuestions_body" }